import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Equipment.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.BulkDensity`]: { uom: 'Mg/m³', format: { nearest: 0.01 } },
      [`${prefix}.Measurements.Volume`]: { uom: 'L', format: { nearest: 0.001 } },
      [`${prefix}.DryingTrays.DryMassReadings.DryingTime`]: { uom: 'h', format: { nearest: 0.01 } },
      [`${prefix}.ImagesAndRemarks.Remarks`]: { maxLength: 255 },
      [`${prefix}.ImagesAndRemarks.InternalRemarks`]: { maxLength: 255 },
      ...getMoistureContentPercent(`${prefix}.Results.MoistureContentPercent`),
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    getLabelConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
      [`${prefix}.Equipment.DryMassBalance`]: { defaultReadability: 1, defaultUom: 'g' },
    }
  );

const getMoistureContentPercent = (name: string) => ({
  [`${name}`]: { format: { nearest: 0.1 }, label: 'Water Content (%)' },
});

export { getConfig, getMoistureContentPercent };

export default {
  [qestIds.moistureContent.BS_EN_1097_5.rev2008]: getConfig,
};
